import { render, staticRenderFns } from "./SwapInsufficientGasStep.vue?vue&type=template&id=53fc593d&scoped=true"
import script from "./SwapInsufficientGasStep.vue?vue&type=script&lang=ts"
export * from "./SwapInsufficientGasStep.vue?vue&type=script&lang=ts"
import style0 from "./SwapInsufficientGasStep.vue?vue&type=style&index=0&id=53fc593d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc593d",
  null
  
)

export default component.exports